import React, { Component } from 'react';
//import { Button } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { TextField, Table, TableCell, Modal, TableBody, Radio, TableHead, TableContainer,  TableRow, Button, Box, Tooltip, Paper, Toolbar, Typography, IconButton, Grid, Badge  } from '@material-ui/core';
import Loader from '../../../loader';
import { connect } from 'react-redux';
import axios from "axios";
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import i18n from '../../../../i18next';
import customStyle from '../../../../Assets/CSS/stylesheet_UHS';
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import Cart from '../../../../Assets/Images/cart.svg'
import {MuiPickersUtilsProvider, KeyboardDatePicker,DatePicker} from '@material-ui/pickers';
import CommonDropFamily from '../CommonPopup/CommonDropFamily';
import CommonDropDwn from '../CommonPopup/CommonDropDwn';
import CommonTable from './CommonTable'
import '../Add-ons/addOnsScreen.css';


const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
      color: '#fa6446',
  },
  tooltip: {
    backgroundColor: '#fa6446',
      border: '1px solid #dadde9',
      fontSize : '12px'
  },
}));

const useStylesBootstrap_otherQuote = makeStyles(theme => ({
    arrow: {
        color: '#4a4b57',
    },
    tooltip: {
        backgroundColor: '#4a4b57',
        border: '1px solid #dadde9',
        fontSize : '12px'
    },
}));


const StyledTableRow = withStyles({
    root: {
        backgroundColor: "#F4F4F4",
        '&.Mui-selected': {
            backgroundColor: "#c0d3a3",
          },
          "&.Mui-selected.MuiTableRow-hover":{
            backgroundColor: "#c0d3a3",
          },
    },
  })(TableRow);


const ProceedButton = withStyles(
    {
        root: {
            backgroundColor: '#b31b44',
            color: '#ffffff',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: '#23436c',
                boxShadow: '0 4px 8px 0 #e0f1ef, 0 2px 4px 0 #e0f1ef',
            },
            '&:focus':{
                outline:'none'
            },
            '&:disabled': {
                backgroundColor: '#BDBDBD',
                color: '#ffffff'
            },
        },
    }

)(Button);

const styles = theme => ({
  table: {
    minWidth: 400,
  },
});




class MultiAddons extends Component {
  constructor(props) {
    super(props);
      this.state = {
        clientid: sessionStorage.getItem("CLIENT_ID"),
        subId:  JSON.parse(localStorage.getItem('CurrentLoginUser')).id,
        loaderShow: this.props.loaderShow,
        addonList:[],
        selected: null,
        planSelectedAmount: null,
        selecdPlanID:null,
        appFeeAmount: null,
        data: null,
        listOfCost:[],
        familyList: [],
        selectedFamily:null,
        step: this.props.indexOfMultiAddons,
        arrayOfAddonAmount:[],
        listofAddonSelected:[],
        coreSelectedFamily: null,
        addonSelectedFamily: [],
        membersCount: 0,
        isDisabled: false,
        isAllstateAddon: this.props.addon?.toLowerCase() === "allstate",
        allstateSelectedPlanCode: null,
        allstateCompletelyDisabled: false
    };
  }

  componentDidMount() {
    let coreValue = localStorage.getItem("selectedCorePlan")
    let isCheck = coreValue?.includes("Secure") || coreValue?.includes("Reserve Plus")
    this.setState({isDisabled: isCheck})
    this.props.isAddonDisabled(isCheck)
    // axios.get(process.env.REACT_APP_BASE_URL+"/plan/getAddonList/"+`/${this.state.clientid}`).then((response)=>{
    //   this.setState({addonList: response.data.response}, () =>{
        this.getAddonData(this.props.addon);
        this.getCorePlanDetails();
        this.getMembersCount();
      // })
    // })
   }


   getAddonData = async (type) =>{
    console.log('this.props.addonSelectedFamily: ', await this.props.addonSelectedFamily[this.props.indexOfMultiAddons]);
    // console.log('this.props.listofAddonSelected: ', await this.props.listofAddonSelected[this.props.indexOfMultiAddons]);
    axios.get(process.env.REACT_APP_BASE_URL+"/plan/getAddonData/"+`${this.state.subId}/${this.state.clientid}/${type}`).then((res)=>{
      this.setState({data: res.data.response, 
        selectedFamily: res.data.response[0].categoryAmountList[0].category
      }, () => {
        const isAllstateAddon = type?.toLowerCase() === "allstate";
        this.setState({ isAllstateAddon });
       
          let listCost= [];
          let familyList =[];
          let addonList=[]
          res.data.response.map((res1) => {
            listCost.push(res1.categoryAmountList[0].amount);
          });
      
          res.data.response.map((res2)=>{
              familyList.push(res2.categoryAmountList[0].category);
          })

          res.data.response.map((res2)=>{
            addonList.push(res2.categoryAmountList[0].planCode);
        })

          this.setState({listOfCost: listCost, familyList: familyList}, () =>{
            axios.get(process.env.REACT_APP_BASE_URL+"/plan/getMemberPlan"+`/${this.state.subId}/${type}`).then((resp)=>{
              // this.setState({loaderShow: false})
              let indexOne=res.data.response.indexOf(res.data.response.filter(x => x.planId === this.props.listofAddonSelected[this.state.step])[0]);
              listCost=[];
              familyList=[];
              addonList=[]
              res.data.response.map((res3, ind) => {
                listCost.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && ind == indexOne) ? this.props.arrayOfAddonAmountBadge[this.props.indexOfMultiAddons] : res3.categoryAmountList && res3.categoryAmountList[0].amount);
                // listCost.push(res.categoryAmountList[0].amount);
              });
              res.data.response.map((res4, ind)=>{
                familyList.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && indexOne == ind) ? this.props.addonSelectedFamily[this.props.indexOfMultiAddons] : res4.categoryAmountList[0].category);
            })
            res.data.response.map((res4, ind)=>{
              addonList.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && indexOne == ind) ? this.props.listofAddonSelected[this.props.indexOfMultiAddons] : res4.categoryAmountList[0].planCode);
          })
              this.setState({selected: indexOne})
              this.setState({listOfCost: listCost, familyList: familyList}, () =>{
              if(resp.data.response){
                let index=res.data.response.indexOf(res.data.response.filter(x => x.planId === resp.data.response.planCode)[0]);
              
                let listofAddonSelected = this.state.listofAddonSelected;
                let addonSelectedFamily = this.props.addonSelectedFamily;
                
                let flagRemoveDepentent = res.data.response[index].categoryAmountList.find(x => x.category === resp.data.response.category) ? true :false;
                
                let family = this.state.familyList;

                // Calculate the correct amount for this addon - use the saved amount from response
                const addonAmount = resp.data.response.amount;
                
                listofAddonSelected[this.state.step] = resp.data.response.planCode;
                addonSelectedFamily[this.state.step] = flagRemoveDepentent ? resp.data.response.category: res.data.response[index].categoryAmountList[0].category;
                
                // Set the amount at the correct index
                this.props.setArrayOfAddonAmount(addonAmount);
                this.props.setArrayOfAddonAmountBadge(addonAmount);
                this.props.setlistofAddonSelected(addonList[indexOne]);
                this.props.setaddonSelectedFamily(family[indexOne]);
                
                // If core plan disables Allstate, keep the previously saved Allstate selection when re-enrolling
                const isDisabledByCoreAllstate = this.state.isDisabled && this.state.data[index].planId?.toLowerCase()?.includes("allstate") && !this.props.reEnrollBySC;

                this.setState({
                  selectedFamily: isDisabledByCoreAllstate ? null : (flagRemoveDepentent ? resp.data.response.category : this.state.data[index].categoryAmountList[0].category),
                  listofAddonSelected: isDisabledByCoreAllstate ? [] : listofAddonSelected,
                  selected: isDisabledByCoreAllstate ? null : index,
                  familyList: family,
                  addonSelectedFamily: isDisabledByCoreAllstate ? [] : addonSelectedFamily,
                  allstateSelectedPlanCode: isAllstateAddon && resp.data.response ? resp.data.response.planCode : null,
                  allstateCompletelyDisabled: isAllstateAddon && !resp.data.response
                });
              }
            })
            })
          })
         
      })
  })
   }
  getCorePlanDetails = () =>{
    axios.get(process.env.REACT_APP_BASE_URL+"/plan/getMemberPlan"+`/${this.state.subId}/Core`).then((resp)=>{
      if(resp.data.response)
        this.setState({
          planSelectedAmount: resp.data.response.amount,
          appFeeAmount: resp.data.response.appFee,
          selecdPlanID: resp.data.response.planCode,
          coreSelectedFamily: resp.data.response.category
        })
        else
        this.props.backStep();
    })
  }

  getMembersCount = () => {
    // fetch member info used elsewhere in the app to determine number of members
    axios.get(process.env.REACT_APP_BASE_URL + "/setupfamily/getBeneficiaryInfoBySubId/" + this.state.subId).then((res) => {
      if (res.data && res.data.response && Array.isArray(res.data.response)) {
        this.setState({ membersCount: res.data.response.length });
      } else if (res.data && res.data.response && typeof res.data.response === 'object') {
        // some endpoints return an object with members array in a property; try common keys
        const resp = res.data.response;
        const arr = resp.members || resp.familyMembers || resp.membersList || [];
        this.setState({ membersCount: Array.isArray(arr) ? arr.length : 0 });
      }
    }).catch(err => {
      console.log('Error fetching members info', err);
      // default to 0 on error
      this.setState({ membersCount: 0 });
    });
  }

    isAllstateRow = (row) => {
      return row?.planId?.toLowerCase()?.includes("allstate");
    }

    shouldDisableRow = (row) => {
      const isAllstateRow = this.isAllstateRow(row);
      const reEnrollGuard = this.props.reEnrollBySC;
      const disabledByCorePlan = reEnrollGuard && this.state.isDisabled && isAllstateRow;

      if (reEnrollGuard && this.state.isAllstateAddon && isAllstateRow) {
        if (this.state.allstateCompletelyDisabled) return true;
        if (this.state.allstateSelectedPlanCode) {
          // Previously selected Allstate plan should remain enabled; disable other Allstate options
          return row.planId !== this.state.allstateSelectedPlanCode;
        }
        // No existing Allstate selection: disable all Allstate options
        return true;
      }

      return disabledByCorePlan;
    }

    handleClick = (index, seletedAddon) => {
      // Allow deselection even when the row is disabled (re-enrollment Allstate behavior)
      if (this.shouldDisableRow(seletedAddon) && this.state.selected !== index) return;
      console.log("::::", index, seletedAddon, this.state.familyList, index)
      if(this.state.selected === index){
        let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
        let listofAddonSelected = this.state.listofAddonSelected;
        let addonSelectedFamily = this.state.addonSelectedFamily;
        addonSelectedFamily[this.state.step] = this.state.familyList[index];
        listofAddonSelected[this.state.step]=null;
        arrayOfAddonAmount[this.state.step]=0;
        this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
        this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
        this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
        // Do not clear stored Allstate selection on deselect so user can reselect the same plan
        this.setState({
          selected: null,
          arrayOfAddonAmount: arrayOfAddonAmount,
          listofAddonSelected: listofAddonSelected,
          addonSelectedFamily: addonSelectedFamily
        });
      }else{
        let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
        let costList =this.state.listOfCost;
        let listofAddonSelected = this.state.listofAddonSelected;
        listofAddonSelected[this.state.step] = seletedAddon.planId;
        let addonSelectedFamily = this.state.addonSelectedFamily;
        addonSelectedFamily[this.state.step] = this.state.familyList[index];
        arrayOfAddonAmount[this.state.step] = costList[index];
        this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
        this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
        this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
        this.setState({
          selected: index,
          arrayOfAddonAmount: arrayOfAddonAmount,
          listofAddonSelected: listofAddonSelected,
          addonSelectedFamily: addonSelectedFamily,
          allstateSelectedPlanCode: (this.props.reEnrollBySC && this.state.isAllstateAddon && this.isAllstateRow(seletedAddon)) ? seletedAddon.planId : this.state.allstateSelectedPlanCode
        });
      }
    };
    selectedClick = (index, seletedAddon) =>{
      if (this.shouldDisableRow(seletedAddon)) return;
      let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
      let costList =this.state.listOfCost;
      let addonSelectedFamily = this.state.addonSelectedFamily;
      addonSelectedFamily[this.state.step] = this.state.familyList[index];
      let listofAddonSelected = this.state.listofAddonSelected;
      listofAddonSelected[this.state.step] = seletedAddon.planId;
      arrayOfAddonAmount[this.state.step] = costList[index];
      this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
      this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
      this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
      this.setState({
        selected: index,
        arrayOfAddonAmount: arrayOfAddonAmount,
        listofAddonSelected:listofAddonSelected,
        addonSelectedFamily: addonSelectedFamily,
        allstateSelectedPlanCode: (this.props.reEnrollBySC && this.state.isAllstateAddon && this.isAllstateRow(seletedAddon)) ? seletedAddon.planId : this.state.allstateSelectedPlanCode
      });
    }
    submitAndNextAddon = () =>{

      let obj = {
            subId: this.state.subId,
            planCode: this.state.data[this.state.selected] ? this.state.data[this.state.selected].planId: null,
            amount: this.state.listOfCost[this.state.selected] ? this.state.listOfCost[this.state.selected]: 0,
            appFee: 0,
            category: this.state.familyList[this.state.selected] ? this.state.familyList[this.state.selected]:  null,
            planType:this.state.addonList[this.state.step]
        }
       
       this.setState({loaderShow: true})
        axios.post(process.env.REACT_APP_BASE_URL+"/plan/saveMemberPlan", obj).then((res)=>{
            this.setState({selected: null, step: this.state.step+1, listOfCost: [], familyList: []}, ()=>{
              this.getAddonData(this.state.addonList[this.state.step]);
            })
        })
           
    }
    SubmitPlanRequest = () =>{
      let obj = {
        subId: this.state.subId,
        planCode: this.state.data[this.state.selected] ? this.state.data[this.state.selected].planId: null,
        amount: this.state.listOfCost[this.state.selected] ? this.state.listOfCost[this.state.selected]: 0,
        appFee: 0,
        category: this.state.familyList[this.state.selected] ? this.state.familyList[this.state.selected]:  null,
        planType:this.state.addonList[this.state.step]
      }
        this.setState({loaderShow: true})
  
         

            this.setState({loaderShow: true})
            axios.post(process.env.REACT_APP_BASE_URL+"/plan/saveMemberPlan", obj).then((res)=>{
                this.setState({selected: null, listOfCost: [], familyList: []}, ()=>{
                  this.props.onClick();
                  this.setState({loaderShow: false})
                })
            }).catch(err=>{
                  console.log(err);
                  this.setState({loaderShow: false})
              })
   
    }
    backScreen = () =>{
      this.setState({loaderShow: true})
      let arrayOfAddonAmount = this.state.arrayOfAddonAmount;
      let listofAddonSelected =this.state.listofAddonSelected;
      listofAddonSelected.pop();
      arrayOfAddonAmount.pop();  
          this.setState({selected: null, step: this.state.step-1, arrayOfAddonAmount: arrayOfAddonAmount, listofAddonSelected: listofAddonSelected, listOfCost: [], familyList: []}, ()=>{
            this.getAddonData(this.state.addonList[this.state.step]);
          })
    }
    render() {
      var totalAmountOfAddon = 0;
      this.props.arrayOfAddonAmount.length> 0 && this.props.arrayOfAddonAmount.map(val=>{
        totalAmountOfAddon+=val?val:0;
      })
    if(this.state.data)
    return (
      <div style={{}}>
        {this.state.loaderShow ? <Loader/> : ''}
     


    
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              key={this.props.key}
              // size={dense ? "small" : "medium"}
            >
              <TableBody>
                {this.state.data.map((row, index) => {
                  const isItemSelected = index === this.state.selected;
                  const isRowDisabled = this.shouldDisableRow(row);
                  console.log(`${this.state.selected} =======>selected ${index} `);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <StyledTableRow
                      hover
                      role="radio"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.planInfo}
                      selected={isItemSelected}
                     
                    >
                      <TableCell padding="checkbox"  style={{paddingTop:0}}  onClick={(event) => isRowDisabled ? event.stopPropagation() : this.handleClick(index, this.state.data[index])}>
                        <Radio
                        disabled={isRowDisabled}
                          checked={isItemSelected}
                          value={row.planInfo}
                          style={{
                            color: isRowDisabled ? "grey" : "#b31b44"
                          }}
                          name="radio-buttons"
                          className="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        style={{paddingTop:0, paddingBottom: 0, color: isRowDisabled && "grey"}}
                        onClick={(event) => isRowDisabled ? event.stopPropagation() : this.handleClick(index, this.state.data[index])}
                      >
                        Add <b style={{color: isRowDisabled && "grey"}}>{row.planId}</b>
                      </TableCell>

                      <TableCell align="left" style={{ width: "10%", paddingTop:0, paddingBottom: 0 }}  onClick={(event) => isRowDisabled ? event.stopPropagation() : this.handleClick(index, this.state.data[index])}>
                      </TableCell>

                      <TableCell align="left" style={{ width: "10%", paddingTop:0, paddingBottom: 0  }}  onClick={(event) => (isRowDisabled || (this.props.reEnrollBySC && this.state.isAllstateAddon && this.isAllstateRow(row))) ? event.stopPropagation() : this.selectedClick(index, this.state.data[index])}>
                        
                        {this.state.familyList[index] && <CommonDropFamily
                          disabled={isRowDisabled || (this.props.reEnrollBySC && this.state.isAllstateAddon && this.isAllstateRow(row))}
                          value={row.categoryAmountList}
                          index={index}
                          selectedIndex={this.state.selected === index}
                          selectedFamily={this.state.familyList[index]}
                          // disableFamily={this.state.membersCount > 9 && (row.planId.includes("Allstate"))}
                          selectCost={(value, ind) => {
                            let list = this.state.listOfCost;
                            let familyList = this.state.familyList;
                            let arrayOfAddonAmount = this.state.arrayOfAddonAmount;
                            let addonSelectedFamily = [];

                            let amount = row.categoryAmountList.filter(
                              (x) => x.category === value
                            )[0].amount;
                            familyList[ind] = value;
                            list[ind] = amount;
                            arrayOfAddonAmount[this.state.step] = amount;
                            addonSelectedFamily[this.state.step] = value;
                            this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
                            this.props.setArrayOfAddonAmountBadge(arrayOfAddonAmount[this.state.step]);
                            this.props.setListOfCost(list)
                            this.setState({selectedFamily: value, listOfCost: list, familyList: familyList, arrayOfAddonAmount: arrayOfAddonAmount, addonSelectedFamily: addonSelectedFamily});
                          }}
                        />}
                      </TableCell>
                      <TableCell align="right" style={{ width: "10%", paddingTop:0, paddingBottom: 0, fontFamily: "Lato", fontSize: "15px", color:"rgba(0, 0, 0, 0.6)"  }}
                       onClick={(event) => (this.state.isDisabled && row.planId?.toLowerCase()?.includes("allstate")) ? event.stopPropagation() : this.handleClick(index, this.state.data[index])}
                      >
                        <span
                          className="cost-per-month"
                          style={{
                            fontWeight: 700,
                            fontSize: "25px",
                            color: isRowDisabled ? "grey" : index===this.state.selected?"#b31b44":"#b31b44"
                          }}
                        >
                          ${this.state.listOfCost[index] ? Number(this.state.listOfCost[index]).toFixed(2): 0}
                        </span>
                        /MONTH
                      </TableCell>
                      <TableCell align="right" style={{ width: "10%", paddingTop:0, paddingBottom: 0  }}>
                      {row.link != null && 
                        <IconButton onClick={(e) => isRowDisabled ? e.stopPropagation() : window.open(row.link)}>
                          <span  style={{ fontSize: 13, fontWeight: "bold", color: isRowDisabled ? "grey" : isItemSelected? "#003e7d" : "#003e7d", width:100 }}>VIEW DETAILS</span>
                          </IconButton>}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
      </div>
    )
    else return <> <Loader/> </>
  }
}

const mapStateToProps = state => {
  return {
    subId: state.subId
  };
}

export default withStyles(styles)(connect(mapStateToProps)(MultiAddons));






